export const renderFirstLetters = (obj) => {
    return `${obj?.firstName ? obj?.firstName?.[0]?.toUpperCase() : ''}${obj?.lastName ? obj?.lastName?.[0]?.toUpperCase() : ''}`
};
